import Config from "./config.js"
import axios from "axios"
import { getToken } from "./auth"
import {Message} from 'element-ui'
import md5 from 'js-md5';
var requestCaches = {};

// 安全深拷贝（JSON 无法序列化时原样返回，如 Error/文件流）
function cloneResult(res) {
    try {
        return JSON.parse(JSON.stringify(res));
    } catch (e) {
        return res;
    }
}
//路由判断 判断时http还是https
var pathTitle = location.protocol
if (pathTitle == "https:" && Config.baseUrl.indexOf(pathTitle) == -1 || pathTitle == "http:" && Config.baseUrl.indexOf(pathTitle) == -1) {
    var value = pathTitle == "https:" ? "http:" : "https:"
    // Config.baseUrl = Config.baseUrl.split(value).join(pathTitle);
    // Config.imgDomain = Config.imgDomain.split(value).join(pathTitle);
}
axios.defaults.baseURL = Config.baseUrl;
let defaultHeader = {
    "X-Requested-With": "XMLHttpRequest",
    "content-type": "application/json"
};
axios.defaults.headers = defaultHeader;
axios.defaults.responseType = "json"
axios.defaults.timeout = 60 * 1000
// axios.defaults.timeout = 100;// 测试请求超时代码，勿删

axios.interceptors.response.use(
    config => {
        // if (config.data.code !== 0) {
        //     Message.error({
        //         message: config.data.message,
        //         type: "error"
        //     });
        //     throw new Error(config.data.message);
        // }
        return config
    },
    error => {
        console.log("error.response"  , error.response);
        // if (error.response && error.response.status === 401) {
        //     window.location.href = '/login';
        // }
        return Promise.reject(error);
    }
)
/**
 * http单个请求
 * @param {object} params 请求参数
 * @param {integer} successCode 接口正常返回结果标识
 *
 * @returns Promise
 */
export default function request(params, successCode = 0, method = "POST") {
    params.header = {...defaultHeader,...params.header || {}};
    if(Config.warehouse_host!==undefined){
        params.header['warehouse-host'] = Config.warehouse_host;
    }else{
        if('warehouse-host' in params.header){
            delete params.header["warehouse-host"];
        }
    }
    var url = params.url // 请求路径
    var data = {
        app_type: "pc",
        app_type_name: "PC"
    }

    var token = getToken()
    if (token) data.token = token

    // 参数
    if (params.data != undefined) Object.assign(data, params.data);
    
    return new Promise((resolve, reject)=>{
        var conf = {
            baseURL: Config.baseUrl,
            url: url,
            method: method,
            data: data,
            params:params.params,
            header: {
                'Accept':'application/json',
                'Content-Type': 'application/json',
                ...params.header
            },
            responseType: params.responseType || 'json',
            
            // onUploadProgress: (progressEvent) => {
            //     // 计算上传进度
            //     console.log(Math.round((progressEvent.loaded * 100) / progressEvent.total));
            // },
            // validateStatus: (status) => {
            //     return status >= 200 && status < 400; // 400以下都算成功
            // }
        } , cacheKey = md5(JSON.stringify(conf));
        requestCaches[cacheKey] = requestCaches[cacheKey] || {conf:conf,loading:false,success:false,result:null};
        var toCallback = (isError , res)=>{
            if(requestCaches[cacheKey].success === null){
                requestCaches[cacheKey].success = isError ? false : true;
                requestCaches[cacheKey].result = res;
                // console.log("axios request" , cacheKey , url, requestCaches[cacheKey]);
            }
            if(isError === true){
                const { error_code } = res || {}
                if (error_code === "TOKEN_EXPIRED") {
                    res.message = "登录已过期，请重新登录";
                }
                if (error_code === "TOKEN_ERROR") {
                    res.message = "登录错误"
                    vue.$store.dispatch("member/remove_token")
                    if (params.forceLogin) {
                        vue.$router.push(`/login?redirect=${encodeURIComponent(vue.$router.history.current.fullPath)}`)
                    }
                }
                typeof params.fail == 'function' && params.fail(res);
                return reject(res)
            }else{
                const { code } = res.data || {}
                if (code == -3 && vue.$route.name != "closed") {
                    vue.$router.push("/closed")
                    return
                }
                if (code == successCode || (code === undefined && res.data instanceof Object)) {
                    typeof params.success == 'function' && params.success(res);
                    return resolve(res.data)
                }
                
                // console.log("http  fail" , url , res.data);
                typeof params.fail == 'function' && params.fail(res);
                return reject(res.data)
            }
        }
        if(url && url.indexOf('/servicer/api') === 0) {
            return toCallback(true,null);
        }
        var timeOut = (!isNaN(Number(params.timeout)) && params.timeout > 0 ? params.timeout * 1000 : axios.defaults.timeout ) + 0 , jT = 250;
        // console.log("axios request" , cacheKey , url , requestCaches[cacheKey].loading === true);
        if(requestCaches[cacheKey].loading === true){
            var requestInterval = setInterval(()=>{
                timeOut -= jT;
                if(timeOut <= 0 || requestCaches[cacheKey].loading === false){
                    clearInterval(requestInterval);
                    var cached = requestCaches[cacheKey];
                    // 深拷贝共享结果：去重缓存会把同一响应对象给多个并发调用方，
                    // 若一方先把对象挂入 Vue 响应式数据，另一方再补挂属性（如购物车的 checked）
                    // 会因属性是后加的而失去响应性，导致视图不更新
                    var payload = cached.success === true ? cloneResult(cached.result) : cached.result;
                    toCallback(cached.success !== true, payload);
                    typeof params.complete == 'function' && params.complete(cached.result);
                }
            } , jT);
        }else{
            requestCaches[cacheKey].loading = true;
            requestCaches[cacheKey].success = null;
            requestCaches[cacheKey].result = null;
            axios({...params,...conf,}).then(res => {
                return toCallback(false,res)
            }).catch(error => toCallback(true,error)).finally((res)=>{
                requestCaches[cacheKey].loading = false;
                typeof params.complete == 'function' && params.complete(res);
            })
        }
    });
}
/**
 * 并发请求
 * @param {array} params 并发请求参数数组，传入数组中对象的顺序要匹配 data 中 url
 * @var 该方法为并发请求，数据会在全部请求完之后才返回
 * 该方法不建议使用。
 */
export function conRequest(params) {
    if (Object.prototype.toString.call(params) != "[object Array]") {
        return Promise.reject({ code: -1, msg: "参数必须为数组" })
    }

    //同步并发
    var quest = params.filter

    return Promise.all(quest)
        .then((res)=>{
            return Promise.resolve(res)
        })
        .catch(error => {
            
            return Promise.reject(error)
        })
}
